module.exports = __webpack_public_path__ + "img/boqinspect1_7-8-2021.de30ac68.jpg";